<div class="list-modal">
  <div class="list-modal__header">
    <h2 class="list-modal__title" id="list-modal-title">{{ title }}</h2>
    <button type="button" class="list-modal__close" aria-label="Close" (click)="close()">
      <span class="material-icons" translate="no">close</span>
    </button>
  </div>

  <div class="list-modal__body">
    <form [formGroup]="form" aria-labelledby="list-modal-title">
      <ng-container formArrayName="allItems">
        @for (item of allItems.controls; track item; let i = $index) {
          <ng-container [formGroupName]="i">
            <div class="list-modal__row">
              <div class="list-modal__row-main">
                <span class="list-modal__name">{{ item.value.name }}</span>
                @if (availableItems[i].sufix) {
                  <span class="list-modal__suffix">{{ availableItems[i].sufix }}</span>
                }
                @if (botTypes[item.value.id]) {
                  <span class="list-modal__chip">{{ botTypes[item.value.id] }}</span>
                }
              </div>
              <button
                type="button"
                class="list-modal__switch"
                [class.list-modal__switch--on]="item.value.isSelected"
                role="switch"
                [attr.aria-checked]="item.value.isSelected"
                [attr.aria-label]="
                  item.value.isSelected
                    ? 'Remove ' + item.value.name + ' from this project'
                    : 'Add ' + item.value.name + ' to this project'
                "
                (click)="toggleRow(item.value.id, !item.value.isSelected)"
              >
                <span class="list-modal__switch-thumb" aria-hidden="true"></span>
              </button>
            </div>
          </ng-container>
        }
      </ng-container>
    </form>
  </div>

  <div class="list-modal__footer">
    <button mat-stroked-button type="button" class="list-modal__done" (click)="close()">Done</button>
  </div>
</div>
